const utils = require('./utils');

/*
MIT License

Copyright (c) 2022 Radu Mariescu-Istodor

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
© 2022 GitHub, Inc.
*/
export default class Visualizer{
    static drawNetwork(ctx,network, title = "Neural Network", titleColour = "white"){
        const margin=50;
        const left=margin;
        const top=margin;

        const width=ctx.canvas.width-margin*2;
        const height=ctx.canvas.height-margin*2;

        const levelHeight=height/network.levels.length;
        
        ctx.textAlign="center";
        ctx.textBaseline="middle";
        ctx.fillStyle="white";
        ctx.strokeStyle="white";
        ctx.font="18px Arial";
        ctx.fillText(title,left + width / 2, top);

        for(let i=network.levels.length-1;i>=0;i--){
            const levelTop=top+
                utils.lerp(
                    height-levelHeight,
                    0,
                    network.levels.length==1
                        ?0.5
                        :i/(network.levels.length-1)
                );

            ctx.setLineDash([7,3]);
            Visualizer.drawLevel(ctx,network.levels[i],
                left,levelTop,
                width,levelHeight,
                i==network.levels.length-1
                    ?['A','B','L','R']
                    :[]
            );
        }
    }

    static drawLevel(ctx,level,left,top,width,height,outputLabels){
        const right=left+width;
        const bottom=top+height;

        const {inputs,outputs,weights,biases}=level;

        for(let i=0;i<inputs.length;i++){
            for(let j=0;j<outputs.length;j++){
                ctx.beginPath();
                ctx.moveTo(
                    Visualizer.#getNodeX(inputs,i,left,right),
                    bottom
                );
                ctx.lineTo(
                    Visualizer.#getNodeX(outputs,j,left,right),
                    top
                );
                ctx.lineWidth=1;
                ctx.strokeStyle=getRGBA(weights[i][j]);
                ctx.stroke();
            }
        }

        const nodeRadius=18;
        for(let i=0;i<inputs.length;i++){
            const x=Visualizer.#getNodeX(inputs,i,left,right);
            ctx.beginPath();
            ctx.arc(x,bottom,nodeRadius,0,Math.PI*2);
            ctx.fillStyle="#000";
            ctx.fill();
            ctx.beginPath();
            ctx.arc(x,bottom,nodeRadius*0.6,0,Math.PI*2);
            ctx.fillStyle=getRGBA(inputs[i]);
            ctx.fill();

            ctx.beginPath();
            ctx.textAlign="center";
            ctx.textBaseline="middle";
            ctx.fillStyle=getRGBAi(inputs[i]);
            ctx.strokeStyle=ctx.fillStyle;
            ctx.font=(nodeRadius*0.7)+"px Arial";
            ctx.fillText(Math.round(inputs[i]*100),x,bottom);
            //ctx.lineWidth=0.5;
            //ctx.setLineDash([]);
            //ctx.strokeText(Math.round(inputs[i]*100),x,bottom);


        }
        
        for(let i=0;i<outputs.length;i++){
            const x=Visualizer.#getNodeX(outputs,i,left,right);
            ctx.beginPath();
            ctx.arc(x,top,nodeRadius,0,Math.PI*2);
            ctx.fillStyle="#000";
            ctx.fill();
            ctx.beginPath();
            ctx.arc(x,top,nodeRadius*0.6,0,Math.PI*2);
            ctx.fillStyle=getRGBA(outputs[i]);
            ctx.fill();

            ctx.beginPath();
            ctx.lineWidth=2;
            ctx.arc(x,top,nodeRadius*0.8,0,Math.PI*2);
            ctx.strokeStyle=getRGBA(biases[i]);
            ctx.setLineDash([3,3]);
            ctx.stroke();
            ctx.setLineDash([]);

            



            if(outputLabels.length > 0){

                var label = '-';

                if (outputLabels.length > outputs.length) {
                    if (outputs[i] > 0) {
                        label = outputLabels[i * 2 + 0];
                    } else if (outputs[i] < 0) {
                        label = outputLabels[i * 2 + 1];
                    }
                } else {
                    label = outputLabels[i];
                }


                var treble = label; //toUTF16(label);

                ctx.beginPath();
                ctx.textAlign="center";
                ctx.textBaseline="middle";
                ctx.fillStyle=getRGBAi(outputs[i]);
                ctx.strokeStyle=ctx.fillStyle;
                ctx.font=(nodeRadius*0.7)+"px Arial";
                ctx.fillText(treble,x,top+nodeRadius*0.1);
                //ctx.lineWidth=0.5;
                //ctx.strokeText(label,x,top+nodeRadius*0.1);
            } else {

                ctx.beginPath();
                ctx.textAlign="center";
                ctx.textBaseline="middle";
                ctx.fillStyle=getRGBAi(outputs[i]);
                ctx.strokeStyle=ctx.fillStyle;
                ctx.font=(nodeRadius*0.7)+"px Arial";
                ctx.fillText(Math.round(outputs[i]*100),x,top+nodeRadius*0.1);

            }
        }
    }



    
    static #getNodeX(nodes,index,left,right){
        return utils.lerp(
            left,
            right,
            nodes.length==1
                ?0.5
                :index/(nodes.length-1)
        );
    }
}

function toUTF16(codePoint) {
    var TEN_BITS = parseInt('1111111111', 2);
    function u(codeUnit) {
        return '\\u'+codeUnit.toString(16).toUpperCase();
    }

    if (codePoint <= 0xFFFF) {
        return u(codePoint);
    }
    codePoint -= 0x10000;

    // Shift right to get to most significant 10 bits
    var leadSurrogate = 0xD800 + (codePoint >> 10);

    // Mask to get least significant 10 bits
    var tailSurrogate = 0xDC00 + (codePoint & TEN_BITS);

    return u(leadSurrogate) + u(tailSurrogate);
}

function getRGBA(value){
    const alpha=Math.abs(value);
    var B=0;
    var G=0;
    var R=0;

    if (value < 0) {
        G=128;
        B=255;
        //R=255;
    } else {
        G=255;
        R=255;
        //B=255;
    }
    return "rgba("+R+","+G+","+B+","+alpha+")";
}

function getRGBAi(value){
    const alpha=1;

    var R=255;
    var G=255;
    var B=255;
    
    if (Math.abs(value) > 0.5) {
        if (value < 0) {
            R=0;
            G=0;
            B=0;
        } else {
            G=0;
            R=0;
            B=0;
        }
    } else {

        //return getRGBA(value);
        // if (value < 0) {
        //     R=255;
        //     //G=255;
        //     //B=255;
        // } else {
        //     G=128;
        //     //R=255;
        //     B=255;
        // }
    }

    return "rgba("+R+","+G+","+B+","+alpha+")";
}